(function () {
  var SHOP_TITLE = /la santa bruja botanica/i;
  var PENTAGRAM =
    '<svg width="SIZE" height="SIZE" viewBox="0 0 24 24" class="CLASS" aria-hidden="true"><polygon points="12,2 15,9 22,9 16.5,13.5 18.5,21 12,17 5.5,21 7.5,13.5 2,9 9,9"></polygon></svg>';

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      }[char];
    });
  }

  function stripHtml(value) {
    return String(value)
      .replace(/<[^>]+>/g, ' ')
      .replace(/&nbsp;/g, ' ')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/\s+/g, ' ')
      .trim();
  }

  function firstMatch(source, pattern) {
    var match = source.match(pattern);
    return match ? match[1] : '';
  }

  function pentagrams(rating, size) {
    var filled = Math.round(Math.min(5, Math.max(0, rating)));
    var html = '';
    var i;
    for (i = 0; i < 5; i += 1) {
      html += PENTAGRAM.replace(/SIZE/g, String(size)).replace(
        'CLASS',
        i < filled ? 'pentagram active' : 'pentagram',
      );
    }
    return (
      '<div class="pentagram-rating" role="img" aria-label="' +
      escapeHtml(String(rating)) +
      ' out of 5">' +
      html +
      '</div>'
    );
  }

  function parseCarouselHtml(html) {
    var wrapperMatch = html.match(
      /<div[^>]*class=['"][^'"]*jdgm-carousel-wrapper[^'"]*['"][^>]*>/i,
    );
    if (!wrapperMatch || wrapperMatch.index == null) return null;
    var slice = html.slice(wrapperMatch.index, wrapperMatch.index + 80000);
    var average = Number.parseFloat(firstMatch(slice, /data-score=['"]([\d.]+)['"]/));
    var count = Number.parseInt(firstMatch(slice, /data-number-of-reviews=['"](\d+)['"]/), 10);
    var reviews = [];
    var seen = {};
    var match;
    var idPattern = /data-review-id=['"]([^'"]+)['"]/g;
    while ((match = idPattern.exec(slice))) {
      var id = match[1];
      if (!id || seen[id]) continue;
      var chunk = slice.slice(match.index, match.index + 4000);
      if (chunk.indexOf('jdgm-carousel-item__review-body') === -1) continue;
      var body = stripHtml(
        firstMatch(chunk, /jdgm-carousel-item__review-body[^>]*>([\s\S]*?)<\/div>/),
      );
      if (body.length < 8) continue;
      var beforeAuthor = chunk.split('jdgm-carousel-item__reviewer-name')[0] || chunk;
      var rating = Math.min(5, (beforeAuthor.match(/jdgm-star jdgm--on/g) || []).length);
      var author = stripHtml(
        firstMatch(chunk, /jdgm-carousel-item__reviewer-name[^>]*>([\s\S]*?)<\/div>/),
      );
      var productTitle = stripHtml(
        firstMatch(chunk, /jdgm-carousel-item__product-title[^>]*>([\s\S]*?)<\/div>/) ||
          firstMatch(chunk, /jdgm-carousel-item__product-image[^>]*alt=['"]([^'"]+)/),
      );
      var productPath = firstMatch(chunk, /href=['"](\/products\/[^'"?#]+)/);
      var isShopReview = !productTitle || SHOP_TITLE.test(productTitle);
      seen[id] = true;
      reviews.push({
        id: id,
        rating: rating || 5,
        author: author || 'Customer',
        body: body,
        productTitle: isShopReview ? '' : productTitle,
        productHandle:
          !isShopReview && productPath
            ? decodeURIComponent(productPath.replace('/products/', ''))
            : '',
      });
    }
    if (!reviews.length) return null;
    return {
      average: Number.isFinite(average) && average > 0 ? average : 5,
      count: Number.isFinite(count) && count > 0 ? count : reviews.length,
      reviews: reviews,
    };
  }

  function parseCarouselDom(wrapper) {
    var reviews = [];
    var seen = {};
    wrapper.querySelectorAll('[data-review-id]').forEach(function (item) {
      var id = item.getAttribute('data-review-id');
      if (!id || seen[id]) return;
      var bodyNode = qs(item, '.jdgm-carousel-item__review-body');
      var body = stripHtml(bodyNode ? bodyNode.innerHTML : '');
      if (body.length < 8) return;
      var authorNode = qs(item, '.jdgm-carousel-item__reviewer-name');
      var titleNode = qs(item, '.jdgm-carousel-item__product-title');
      var link = qs(item, 'a[href*="/products/"]');
      var productTitle = stripHtml(titleNode ? titleNode.textContent : '');
      var productPath = link ? link.getAttribute('href') || '' : '';
      var handleMatch = productPath.match(/\/products\/([^/?#]+)/);
      var isShopReview = !productTitle || SHOP_TITLE.test(productTitle);
      seen[id] = true;
      reviews.push({
        id: id,
        rating: Math.min(5, item.querySelectorAll('.jdgm-star.jdgm--on').length) || 5,
        author: stripHtml(authorNode ? authorNode.textContent : '') || 'Customer',
        body: body,
        productTitle: isShopReview ? '' : productTitle,
        productHandle: !isShopReview && handleMatch ? decodeURIComponent(handleMatch[1]) : '',
      });
    });
    if (!reviews.length) return null;
    var scoreNode = qs(wrapper, '[data-score], .jdgm-all-reviews-rating');
    var countNode = qs(wrapper, '.jdgm-all-reviews-count, [data-number-of-reviews]');
    var average = Number.parseFloat(
      (scoreNode && (scoreNode.getAttribute('data-score') || scoreNode.textContent)) || '',
    );
    var count = Number.parseInt(
      (countNode &&
        (countNode.getAttribute('data-number-of-reviews') || countNode.textContent)) ||
        '',
      10,
    );
    return {
      average: Number.isFinite(average) && average > 0 ? average : 5,
      count: Number.isFinite(count) && count > 0 ? count : reviews.length,
      reviews: reviews,
    };
  }

  function bindRail(rail) {
    if (rail.dataset.bound === 'true') return;
    rail.dataset.bound = 'true';
    var track = qs(rail, '[data-rail-track]');
    var prev = qs(rail, '[data-rail-prev]');
    var next = qs(rail, '[data-rail-next]');
    if (!track) return;

    var update = function () {
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = maxScroll <= 4 || track.scrollLeft >= maxScroll - 4;
    };

    var step = function () {
      var card = qs(track, '.home-review-card');
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 16;
      return card ? card.offsetWidth + gap : track.clientWidth * 0.75;
    };

    var scrollByDir = function (dir) {
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      var nextLeft = Math.max(0, Math.min(maxScroll, track.scrollLeft + dir * step()));
      track.scrollTo({ left: nextLeft, behavior: 'smooth' });
    };

    if (prev) prev.addEventListener('click', function () { scrollByDir(-1); });
    if (next) next.addEventListener('click', function () { scrollByDir(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function render(root, data) {
    var summary = qs(root, '[data-reviews-summary]');
    var track = qs(root, '[data-rail-track]');
    var empty = qs(root, '[data-reviews-empty]');
    var widget = qs(root, '.jdgm-carousel-wrapper');
    var word = root.getAttribute('data-reviews-word') || 'reviews';
    if (!track) return;

    if (summary) {
      summary.hidden = false;
      summary.innerHTML =
      pentagrams(data.average, 16) +
      '<span>' +
      escapeHtml(data.average.toFixed(2)) +
      ' · ' +
      escapeHtml(String(data.count)) +
      ' ' +
      escapeHtml(word) +
      '</span>';
    }

    track.innerHTML = data.reviews
      .map(function (review) {
        var href = review.productHandle
          ? '/products/' + review.productHandle + '#reviews'
          : '';
        var product = '';
        if (review.productTitle && href) {
          product =
            '<a class="home-review-card__product-name" href="' +
            escapeHtml(href) +
            '">' +
            escapeHtml(review.productTitle) +
            '</a>';
        } else if (review.productTitle) {
          product =
            '<p class="home-review-card__product-name">' +
            escapeHtml(review.productTitle) +
            '</p>';
        }
        return (
          '<article class="home-review-card home-review-card--quote">' +
          pentagrams(review.rating, 14) +
          '<p class="home-review-card__quote">“' +
          escapeHtml(review.body) +
          '”</p>' +
          '<p class="home-review-card__author">' +
          escapeHtml(review.author) +
          '</p>' +
          product +
          '</article>'
        );
      })
      .join('');

    if (empty) empty.hidden = true;
    if (widget) widget.classList.add('is-replaced');
    var rail = qs(root, '[data-product-rail]');
    if (rail) {
      rail.hidden = false;
      if (typeof rail._updateArrows === 'function') rail._updateArrows();
      else bindRail(rail);
    }
  }

  function loadFromCache(root) {
    var shop = root.getAttribute('data-shop-domain') || '';
    var token = root.getAttribute('data-public-token') || '';
    if (!shop) return Promise.resolve(null);
    var url = new URL('https://cache.judge.me/widgets/shopify/' + shop);
    if (token) url.searchParams.set('public_token', token);
    url.searchParams.set('featured_carousel', '1');
    url.searchParams.set('all_reviews_count', '1');
    url.searchParams.set('all_reviews_rating', '1');
    return fetch(url.toString(), { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .then(function (payload) {
        if (!payload || !payload.featured_carousel) return null;
        var parsed = parseCarouselHtml(payload.featured_carousel);
        if (!parsed) return null;
        var average = Number.parseFloat(String(payload.all_reviews_rating || ''));
        var count = Number.parseInt(String(payload.all_reviews_count || ''), 10);
        return {
          average: Number.isFinite(average) && average > 0 ? average : parsed.average,
          count: Number.isFinite(count) && count > 0 ? count : parsed.count,
          reviews: parsed.reviews,
        };
      })
      .catch(function () {
        return null;
      });
  }

  function waitForWidget(root) {
    return new Promise(function (resolve) {
      var wrapper = qs(root, '.jdgm-carousel-wrapper');
      if (!wrapper) {
        resolve(null);
        return;
      }
      var attempts = 0;
      var maxAttempts = 40;
      var tick = function () {
        var parsed = parseCarouselDom(wrapper);
        if (parsed) {
          resolve(parsed);
          return;
        }
        attempts += 1;
        if (attempts >= maxAttempts) {
          resolve(null);
          return;
        }
        window.setTimeout(tick, 500);
      };
      tick();
    });
  }

  function init(root) {
    if (root.dataset.loaded === 'true') return;
    root.dataset.loaded = 'true';
    var wrapper = qs(root, '.jdgm-carousel-wrapper');
    var fromDom = wrapper ? parseCarouselDom(wrapper) : null;
    if (fromDom) {
      render(root, fromDom);
      return;
    }
    loadFromCache(root).then(function (fromCache) {
      if (fromCache) {
        render(root, fromCache);
        return;
      }
      waitForWidget(root).then(function (fromWidget) {
        if (fromWidget) render(root, fromWidget);
      });
    });
  }

  document.querySelectorAll('[data-home-reviews]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-home-reviews]');
    if (root) {
      root.dataset.loaded = '';
      init(root);
    }
  });
})();
